(() => {
  angular
    .module('complianceFrameworkApp.complianceServices')
    .controller('QuickGuideController', QuickGuideController);

  /* ngInject */
  function QuickGuideController($document, $stateParams, quickGuideService, sessionService) {
    const vm = this;

    vm.downloadAttachment = downloadAttachment;
    vm.quickGuide = getQuickGuide();

    function getQuickGuide() {
      return quickGuideService(sessionService.getAuthToken()).get({id: $stateParams.id});
    }

    function downloadAttachment(attachment) {
      quickGuideService(sessionService.getAuthToken()).downloadAttachment({id: vm.quickGuide.id, attachmentId: attachment.id}, (response) => {
        let downloadElement = $document.createElement('a');
        downloadElement.href = `data:${attachment.asset_content_type},${encodeURI(response.content)}`;
        downloadElement.target = '_blank';
        downloadElement.download = attachment.asset_file_name;
        downloadElement.click();
      });
    }
  }
})();
